/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const fullscreen_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m.75 23.25 8-8m-8 8h5m-5 0v-5m14.5-9.5 8-8m0 0v5m0-5h-5M.75.75l8 8m-8-8v5m0-5h5m9.5 14.5 8 8m0 0h-5m5 0v-5"
    />
  </svg>
)
export default fullscreen_medium
